<template>
    <v-data-table :headers="headers" :items="items" :options.sync="options" class="elevation-1" :sort-by="'created_at'" :sort-desc="true" :loading="loading" :server-items-length="itemsTotal" :footer-props="{itemsPerPageOptions : $root.OPTIONS_PER_PAGE_DATATABLE}" @update:options="">
        <template v-slot:item.disponible="{item}">
            <v-chip v-if="item.disponible" dark class="green">
                Disponible
            </v-chip>
            <v-chip v-else dark :class="{'teal' : item.dispobible, 'gray' : !item.dispobible}">
                {{ item.dispobible ? 'Disponible' : 'No Disponible' }}
            </v-chip>
        </template>
        <template v-slot:item.synced_at_for_humans="{item}">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ item.synced_at_for_humans }}</span>
                </template>
                <span>{{ item.synced_at }}</span>
            </v-tooltip>
        </template>
        <template v-slot:item.position="{item}">
            {{item.position.latitude}} - {{item.position.longitude}}
        </template>
        <template v-slot:item.pedido_activo="{item}">
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-icon small class="mr-2" v-on="on" v-text="'mdi-star'" :color="(marcar_a && marcar_a.email === item.email)?'green':'red'" @click="marcar(item)">
                    </v-icon>
                </template>
                <span>Marcar Vendedor</span>
            </v-tooltip>
            <v-tooltip left v-if="item && item.pedido_activo">
                <template v-slot:activator="{ on }">
                    <v-icon small class="mr-2" v-on="on" v-text="'mdi-eye'" color="blue" @click="verPedido(item)">
                    </v-icon>
                </template>
                <span>Ver Pedido</span>
            </v-tooltip>
        </template>
    </v-data-table>
</template>

<script>
    import axios from 'axios';
    import EventBus from "@/EventBus";
    export default {
        name: "ReporteVendedoresFirebase",
        props: {
            items: {
                type: Array,
                default: []
            },
            marcar_a: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                headers: [
                    {
                        text: 'Vendedor',
                        align: 'center',
                        sortable: false,
                        value: 'nombre_completo',
                        width: '30px'
                    },
                    {
                        text: 'Correo',
                        align: 'left',
                        sortable: false,
                        value: 'email',
                        width: '150px'
                    },
                    {
                        text: 'Visto por última vez',
                        align: 'left',
                        sortable: false,
                        value: 'synced_at_for_humans',
                        width: '50px'
                    },
                    {
                        text: 'Disponible',
                        align: 'left',
                        sortable: false,
                        value: 'disponible',
                        width: '50px'
                    },
                    {
                        text: 'Pedido',
                        align: 'left',
                        sortable: false,
                        value: 'pedido_activo',
                        width: '50px'
                    }
                ],
                loading: false,
                options: {
                    descending: true,
                    page: 1,
                    itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
                    totalItems: 0
                }
            }
        },
        computed: {
            itemsTotal() {
                return this.items.length
            }
        },
        methods: {
            marcar(item) {
                if (item) {
                    this.$emit('vendedor:marcar', item);
                }
            },
            verPedido({ pedido_activo }) {
                this.$router.push({ name: 'pedido-detalles', params: { pedidoId: pedido_activo } });
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>